import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const procurementTopProductsWidget: DashboardWidgetConfiguration = {
  widgetId: 'procurement.top-products', name: 'Most-purchased products',
  description: 'Top 50 products by confirmed Purchase Order quantity in the selected period. Excludes draft RFQs and cancelled purchases; units are the saved order units.',
  apps: ['procurement'], template: 'report',
  query: {kind: 'single', query: {
    version: 1, source: 'procurement.product-lines', ...period(30),
    select: [
      {type: 'field', field: 'product_name', as: 'product_name'},
      {type: 'field', field: 'uom_name', as: 'unit'},
      {type: 'aggregate', function: 'sum', field: 'quantity', as: 'quantity'},
    ],
    group_by: [{field: 'product_id'}, {field: 'product_name'}, {field: 'uom_name'}],
    having: {type: 'condition', expression: {type: 'aggregate', function: 'sum', field: 'quantity'}, operator: 'gt', value: 0},
    order_by: [{ref: 'quantity', direction: 'desc'}, {ref: 'product_name', direction: 'asc'}], limit: 50,
  }},
  inputs: {title: 'Most-purchased products', subtitle: 'Top 50 · confirmed purchase quantities · order units',
    output: 'category_series', visualization: 'treemap', icon: 'orders', showTimeControls: true,
    colors: ['#206bc4', '#087f5b', '#9c4a00', '#b02525', '#862e9c'], emptyText: 'No confirmed product purchases for this period.'},
  dummyData: {value: '50 products', series: [50, 30, 20, 12, 8]},
  limits: {minWidth: 6, maxWidth: 12, minHeight: 4, maxHeight: 8, defaultWidth: 12, defaultHeight: 5},
};
